import { StructuredBriefFile } from '__generated__/StructuredBriefFile';
import { Uploader } from '__generated__/Uploader';
import Text from 'common/components/Text';
import TextArea from 'common/components/TextArea';
import AttachmentUploader from 'common/components/uploader/AttachmentUploader';
import OtherField from 'projects/components/BriefFields/OtherField';
import ContentSetting from 'projects/components/ContentSetting';
import { ObservableField, ObservableForm } from 'projects/components/ObservableForm';
import { trackViewedBriefEvent } from 'projects/events';
import React, { useEffect } from 'react';

interface Fields {
    title: string;
    description: string;
    googleDriveUrl: string;
    existingWebsite: string;
    referenceFiles: StructuredBriefFile[];
    other: string;
}

export interface Props<T> {
    form: ObservableForm<T>;
    brief: {
        id: string;
        uploader: Uploader;
    };
}

function DetailsPage<T extends Fields>(props: Props<T>) {
    const { form, brief } = props;

    useEffect(() => {
        trackViewedBriefEvent({ id: brief.id, page: 'Details' });
    }, []);

    return (
        <ContentSetting>
            <ObservableField
                form={form}
                name="title"
                title={__('Restaurant name')}
                required
                render={() => <Text fill {...form.attach('title')} />}
            />
            <ObservableField
                form={form}
                name="description"
                title={__('Describe your restaurant')}
                required
                render={() => (
                    <TextArea style={{ minHeight: 200 }} fill {...form.attach('description')} />
                )}
            />
            <ObservableField
                form={form}
                name="referenceFiles"
                title={__('Add any additional reference files')}
                message={__(
                    'Upload any files that your designer needs including your logo, photos, brand guide, fonts, copy, and any other documents.'
                )}
                render={() => (
                    <AttachmentUploader
                        uploader={brief.uploader}
                        {...form.attach('referenceFiles')}
                    />
                )}
            />

            <ObservableField
                form={form}
                name="existingWebsite"
                title={__('Link to your existing website or social sites if you have any')}
                render={() => (
                    <Text
                        placeholder={__('www.example.com')}
                        fill={true}
                        {...form.attach('existingWebsite')}
                    />
                )}
            />
            <OtherField form={form} />
        </ContentSetting>
    );
}

export default DetailsPage;
